import {
  MostQuerySuggestedTask,
  MostScheduledJobsDocument,
} from 'src/graphql/generated/graphql';
import { ActionsColumn, Callout, Typography } from '@otp/ui';
import { useTranslation } from 'react-i18next';
import { Play, Alert } from '@otp/icons';
import { DocumentNode } from 'graphql';
import { ScheduleButton } from 'src/components/most/list/history/item/suggested-tasks/columns/actions/schedule-button';
import { RunCommand } from 'src/components/most/common/run-command';

type SuggestedTasksFieldProps = {
  store: {
    nationalStoreNumber: string;
    id: string;
  };
  tasks: MostQuerySuggestedTask[];
  refetchQueries: DocumentNode[];
};

export const SuggestedTasksField = ({
  store,
  tasks,
  refetchQueries,
}: SuggestedTasksFieldProps) => {
  return (
    <div className="flex flex-col gap-1">
      {tasks.map((task, index) => (
        <Callout
          key={index}
          severity="error"
          icon={false}
          className="border border-solid border-red-200 rounded-lg px-3 py-0"
        >
          <SuggestedTaskContent
            store={store}
            task={task}
            refetchQueries={refetchQueries}
          />
        </Callout>
      ))}
    </div>
  );
};

const SuggestedTaskContent = ({
  store,
  task,
  refetchQueries,
}: {
  store: {
    nationalStoreNumber: string;
    id: string;
  };
  task: MostQuerySuggestedTask;
  refetchQueries: DocumentNode[];
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix: 'most.list.history.columns',
  });

  const taskName = task?.problemDefinition?.name;
  const devices = task?.computersWithProblem?.join(', ');

  const actions = [
    {
      icon: (
        <RunCommand
          command={{
            device: task.computersWithProblem as string[],
            nationalStoreNumber: store.nationalStoreNumber,
            triageId: task.problemDefinition?.triageId,
          }}
          task={{
            task: task,
            storeId: store.id,
            nationalStoreNumber: store.nationalStoreNumber,
          }}
          refetchQueries={refetchQueries}
        >
          <Play />
        </RunCommand>
      ),
    },
    {
      icon: (
        <ScheduleButton
          storeId={store.id}
          task={task}
          refetchQueries={[...refetchQueries, MostScheduledJobsDocument]}
        />
      ),
    },
  ];

  return (
    <div className="w-full flex justify-between items-center">
      <Typography variant="subtitle1" fontWeight="bold" className="flex gap-1">
        <Alert />
        <div>
          {t('expandable-content')}: {taskName}
          {devices && ` - ${devices}`}
        </div>
      </Typography>

      <div>
        <ActionsColumn icons={actions} />
      </div>
    </div>
  );
};
